module.exports = __webpack_public_path__ + "static/media/Refill.9f67aca2.svg";